unit unit_Logbuch;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Connection, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Vcl.Grids, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, strutils,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTableView, WEBLib.Grids, WEBLib.Buttons, DB;

type
  TfrmLogbuch = class(TForm)
    DataSet: TXDataWebDataSet;
    Source: TDataSource;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    TC: TTableControl;
    btnzurueck: TButton;
    edtSuchbegriff: TEdit;
    DataSetID: TIntegerField;
    DataSetDatumUhrzeit: TDateTimeField;
    DataSetApplicationCode: TStringField;
    DataSetApplicationName: TStringField;
    DataSetVersionsdatum: TDateTimeField;
    DataSetInstalCode: TStringField;
    DataSetFreischaltungVON: TDateTimeField;
    DataSetFreischaltungBIS: TDateTimeField;
    DataSetAbsenderzeile: TStringField;
    DataSetPCCode: TStringField;
    DataSetVertriebspartner: TIntegerField;
    DataSetLetzterStart: TDateTimeField;
    DataSetAnzahlStart: TIntegerField;
    DataSetDatumUhrzeitUser: TDateTimeField;
    DataSetWindowsUserName: TStringField;
    DataSetCadiaKundennummer: TStringField;
    DataSetPCName: TStringField;
    DataSetAvIsTrial: TBooleanField;
    DataSetAvAuthorized: TBooleanField;
    DataSetAvRegistered: TBooleanField;
    DataSetAvExpired: TBooleanField;
    DataSetSysNachname: TStringField;
    DataSetSysVorname: TStringField;
    DataSetNetzwerk: TBooleanField;
    DataSetDBKEY: TStringField;
    DataSetVerarbeitung: TStringField;
    DataSetCadiaModSumme: TFloatField;
    DataSetASPVersion: TStringField;
    DataSetCSPName: TStringField;
    DataSetCSPVendor: TStringField;
    DataSetCPUName: TStringField;
    DataSetCPUID: TStringField;
    DataSetBaseBoardSerial: TStringField;
    DataSetHDDVolLetter: TStringField;
    DataSetHDDVolSerial: TStringField;
    DataSetSQLDB: TStringField;
    DataSetIPAdresse: TStringField;
    DataSetInstanzID: TStringField;
    DataSetProgrammpfad: TStringField;
    DataSetLocalIP: TStringField;
    DataSetMACAddress: TStringField;
    DataSetVersionsnummer: TStringField;
    DataSetDatenpfad: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure DataSetAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);

    public

  protected procedure LoadDFMValues; override; end;

var
  frmLogbuch: TfrmLogbuch;

implementation
  uses unit1, unit2;
{$R *.dfm}


procedure TfrmLogbuch.btnzurueckClick(Sender: TObject);
begin
  dataset.close;
  self.Close;
end;


procedure TfrmLogbuch.DataSetAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  myelement:=container3.ElementHandle;
  tc.ParentElement:=myelement;
  i:=0;
  TC.visible:=true;
  TC.ColCount:=3;
  tc.RowCount:=dataset.RecordCount+1;
  tc.Cells[0,i]:='<b>Datum';
  tc.Cells[1,i]:='<b>Programm';
  tc.Cells[2,i]:='<b>Infos';
  dataset.First;

  while not dataset.eof do
  begin
    inc(i);
    TC.Cells[0,i]:=DataSetDatumUhrzeit.AsString;
    TC.Cells[1,i]:=DataSetApplicationName.AsString;
    TC.Cells[2,i]:=DataSetCadiaKundennummer.AsString+' | '+DataSetPCName.asstring+' | '+DataSetWindowsUserName.asstring+'<br>'+DataSetAbsenderzeile.AsString+'<br>'+DataSetVersionsdatum.AsString+' | '+DataSetVersionsnummer.asstring;
    dataset.Next;
  end;

end;

procedure TfrmLogbuch.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Logbuch</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  dataset.Load;
end;

procedure TfrmLogbuch.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  TC := TTableControl.Create(Self);
  btnzurueck := TButton.Create(Self);
  edtSuchbegriff := TEdit.Create(Self);
  DataSet := TXDataWebDataSet.Create(Self);
  DataSetID := TIntegerField.Create(Self);
  DataSetDatumUhrzeit := TDateTimeField.Create(Self);
  DataSetApplicationCode := TStringField.Create(Self);
  DataSetApplicationName := TStringField.Create(Self);
  DataSetVersionsdatum := TDateTimeField.Create(Self);
  DataSetInstalCode := TStringField.Create(Self);
  DataSetFreischaltungVON := TDateTimeField.Create(Self);
  DataSetFreischaltungBIS := TDateTimeField.Create(Self);
  DataSetAbsenderzeile := TStringField.Create(Self);
  DataSetPCCode := TStringField.Create(Self);
  DataSetVertriebspartner := TIntegerField.Create(Self);
  DataSetLetzterStart := TDateTimeField.Create(Self);
  DataSetAnzahlStart := TIntegerField.Create(Self);
  DataSetDatumUhrzeitUser := TDateTimeField.Create(Self);
  DataSetWindowsUserName := TStringField.Create(Self);
  DataSetCadiaKundennummer := TStringField.Create(Self);
  DataSetPCName := TStringField.Create(Self);
  DataSetAvIsTrial := TBooleanField.Create(Self);
  DataSetAvAuthorized := TBooleanField.Create(Self);
  DataSetAvRegistered := TBooleanField.Create(Self);
  DataSetAvExpired := TBooleanField.Create(Self);
  DataSetSysNachname := TStringField.Create(Self);
  DataSetSysVorname := TStringField.Create(Self);
  DataSetNetzwerk := TBooleanField.Create(Self);
  DataSetDBKEY := TStringField.Create(Self);
  DataSetVerarbeitung := TStringField.Create(Self);
  DataSetCadiaModSumme := TFloatField.Create(Self);
  DataSetASPVersion := TStringField.Create(Self);
  DataSetCSPName := TStringField.Create(Self);
  DataSetCSPVendor := TStringField.Create(Self);
  DataSetCPUName := TStringField.Create(Self);
  DataSetCPUID := TStringField.Create(Self);
  DataSetBaseBoardSerial := TStringField.Create(Self);
  DataSetHDDVolLetter := TStringField.Create(Self);
  DataSetHDDVolSerial := TStringField.Create(Self);
  DataSetSQLDB := TStringField.Create(Self);
  DataSetIPAdresse := TStringField.Create(Self);
  DataSetInstanzID := TStringField.Create(Self);
  DataSetProgrammpfad := TStringField.Create(Self);
  DataSetLocalIP := TStringField.Create(Self);
  DataSetMACAddress := TStringField.Create(Self);
  DataSetVersionsnummer := TStringField.Create(Self);
  DataSetDatenpfad := TStringField.Create(Self);
  Source := TDataSource.Create(Self);

  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  DataSet.BeforeLoadDFMValues;
  DataSetID.BeforeLoadDFMValues;
  DataSetDatumUhrzeit.BeforeLoadDFMValues;
  DataSetApplicationCode.BeforeLoadDFMValues;
  DataSetApplicationName.BeforeLoadDFMValues;
  DataSetVersionsdatum.BeforeLoadDFMValues;
  DataSetInstalCode.BeforeLoadDFMValues;
  DataSetFreischaltungVON.BeforeLoadDFMValues;
  DataSetFreischaltungBIS.BeforeLoadDFMValues;
  DataSetAbsenderzeile.BeforeLoadDFMValues;
  DataSetPCCode.BeforeLoadDFMValues;
  DataSetVertriebspartner.BeforeLoadDFMValues;
  DataSetLetzterStart.BeforeLoadDFMValues;
  DataSetAnzahlStart.BeforeLoadDFMValues;
  DataSetDatumUhrzeitUser.BeforeLoadDFMValues;
  DataSetWindowsUserName.BeforeLoadDFMValues;
  DataSetCadiaKundennummer.BeforeLoadDFMValues;
  DataSetPCName.BeforeLoadDFMValues;
  DataSetAvIsTrial.BeforeLoadDFMValues;
  DataSetAvAuthorized.BeforeLoadDFMValues;
  DataSetAvRegistered.BeforeLoadDFMValues;
  DataSetAvExpired.BeforeLoadDFMValues;
  DataSetSysNachname.BeforeLoadDFMValues;
  DataSetSysVorname.BeforeLoadDFMValues;
  DataSetNetzwerk.BeforeLoadDFMValues;
  DataSetDBKEY.BeforeLoadDFMValues;
  DataSetVerarbeitung.BeforeLoadDFMValues;
  DataSetCadiaModSumme.BeforeLoadDFMValues;
  DataSetASPVersion.BeforeLoadDFMValues;
  DataSetCSPName.BeforeLoadDFMValues;
  DataSetCSPVendor.BeforeLoadDFMValues;
  DataSetCPUName.BeforeLoadDFMValues;
  DataSetCPUID.BeforeLoadDFMValues;
  DataSetBaseBoardSerial.BeforeLoadDFMValues;
  DataSetHDDVolLetter.BeforeLoadDFMValues;
  DataSetHDDVolSerial.BeforeLoadDFMValues;
  DataSetSQLDB.BeforeLoadDFMValues;
  DataSetIPAdresse.BeforeLoadDFMValues;
  DataSetInstanzID.BeforeLoadDFMValues;
  DataSetProgrammpfad.BeforeLoadDFMValues;
  DataSetLocalIP.BeforeLoadDFMValues;
  DataSetMACAddress.BeforeLoadDFMValues;
  DataSetVersionsnummer.BeforeLoadDFMValues;
  DataSetDatenpfad.BeforeLoadDFMValues;
  Source.BeforeLoadDFMValues;
  try
    Name := 'frmLogbuch';
    Width := 223;
    Height := 376;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex m-1';
    Container3.HeightStyle := ssAuto;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 141;
    TC.Width := 169;
    TC.Height := 79;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 1;
    TC.RowCount := 5;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 226;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 8;
    edtSuchbegriff.Top := 296;
    edtSuchbegriff.Width := 150;
    edtSuchbegriff.Height := 22;
    edtSuchbegriff.ChildOrder := 6;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.ShowHint := True;
    edtSuchbegriff.TextHint := 'Suchbegriff eingeben';
    edtSuchbegriff.WidthPercent := 60.000000000000000000;
    DataSet.SetParentComponent(Self);
    DataSet.Name := 'DataSet';
    DataSet.AfterOpen := DataSetAfterOpen;
    DataSet.EntitySetName := 'Logbuch';
    DataSet.Connection := DM2.XDataWebConnection1;
    DataSet.QueryString := '$orderby=ID DESC';
    DataSet.QueryTop := 100;
    DataSet.Left := 8;
    DataSet.Top := 56;
    DataSetID.SetParentComponent(DataSet);
    DataSetID.Name := 'DataSetID';
    DataSetID.FieldName := 'ID';
    DataSetID.Required := True;
    DataSetDatumUhrzeit.SetParentComponent(DataSet);
    DataSetDatumUhrzeit.Name := 'DataSetDatumUhrzeit';
    DataSetDatumUhrzeit.FieldName := 'DatumUhrzeit';
    DataSetApplicationCode.SetParentComponent(DataSet);
    DataSetApplicationCode.Name := 'DataSetApplicationCode';
    DataSetApplicationCode.FieldName := 'ApplicationCode';
    DataSetApplicationCode.Size := 25;
    DataSetApplicationName.SetParentComponent(DataSet);
    DataSetApplicationName.Name := 'DataSetApplicationName';
    DataSetApplicationName.FieldName := 'ApplicationName';
    DataSetApplicationName.Size := 50;
    DataSetVersionsdatum.SetParentComponent(DataSet);
    DataSetVersionsdatum.Name := 'DataSetVersionsdatum';
    DataSetVersionsdatum.FieldName := 'Versionsdatum';
    DataSetInstalCode.SetParentComponent(DataSet);
    DataSetInstalCode.Name := 'DataSetInstalCode';
    DataSetInstalCode.FieldName := 'InstalCode';
    DataSetInstalCode.Size := 25;
    DataSetFreischaltungVON.SetParentComponent(DataSet);
    DataSetFreischaltungVON.Name := 'DataSetFreischaltungVON';
    DataSetFreischaltungVON.FieldName := 'FreischaltungVON';
    DataSetFreischaltungBIS.SetParentComponent(DataSet);
    DataSetFreischaltungBIS.Name := 'DataSetFreischaltungBIS';
    DataSetFreischaltungBIS.FieldName := 'FreischaltungBIS';
    DataSetAbsenderzeile.SetParentComponent(DataSet);
    DataSetAbsenderzeile.Name := 'DataSetAbsenderzeile';
    DataSetAbsenderzeile.FieldName := 'Absenderzeile';
    DataSetAbsenderzeile.Size := 100;
    DataSetPCCode.SetParentComponent(DataSet);
    DataSetPCCode.Name := 'DataSetPCCode';
    DataSetPCCode.FieldName := 'PCCode';
    DataSetPCCode.Size := 25;
    DataSetVertriebspartner.SetParentComponent(DataSet);
    DataSetVertriebspartner.Name := 'DataSetVertriebspartner';
    DataSetVertriebspartner.FieldName := 'Vertriebspartner';
    DataSetLetzterStart.SetParentComponent(DataSet);
    DataSetLetzterStart.Name := 'DataSetLetzterStart';
    DataSetLetzterStart.FieldName := 'LetzterStart';
    DataSetAnzahlStart.SetParentComponent(DataSet);
    DataSetAnzahlStart.Name := 'DataSetAnzahlStart';
    DataSetAnzahlStart.FieldName := 'AnzahlStart';
    DataSetDatumUhrzeitUser.SetParentComponent(DataSet);
    DataSetDatumUhrzeitUser.Name := 'DataSetDatumUhrzeitUser';
    DataSetDatumUhrzeitUser.FieldName := 'DatumUhrzeitUser';
    DataSetWindowsUserName.SetParentComponent(DataSet);
    DataSetWindowsUserName.Name := 'DataSetWindowsUserName';
    DataSetWindowsUserName.FieldName := 'WindowsUserName';
    DataSetWindowsUserName.Size := 100;
    DataSetCadiaKundennummer.SetParentComponent(DataSet);
    DataSetCadiaKundennummer.Name := 'DataSetCadiaKundennummer';
    DataSetCadiaKundennummer.FieldName := 'CadiaKundennummer';
    DataSetCadiaKundennummer.Size := 13;
    DataSetPCName.SetParentComponent(DataSet);
    DataSetPCName.Name := 'DataSetPCName';
    DataSetPCName.FieldName := 'PCName';
    DataSetPCName.Size := 50;
    DataSetAvIsTrial.SetParentComponent(DataSet);
    DataSetAvIsTrial.Name := 'DataSetAvIsTrial';
    DataSetAvIsTrial.FieldName := 'AvIsTrial';
    DataSetAvAuthorized.SetParentComponent(DataSet);
    DataSetAvAuthorized.Name := 'DataSetAvAuthorized';
    DataSetAvAuthorized.FieldName := 'AvAuthorized';
    DataSetAvRegistered.SetParentComponent(DataSet);
    DataSetAvRegistered.Name := 'DataSetAvRegistered';
    DataSetAvRegistered.FieldName := 'AvRegistered';
    DataSetAvExpired.SetParentComponent(DataSet);
    DataSetAvExpired.Name := 'DataSetAvExpired';
    DataSetAvExpired.FieldName := 'AvExpired';
    DataSetSysNachname.SetParentComponent(DataSet);
    DataSetSysNachname.Name := 'DataSetSysNachname';
    DataSetSysNachname.FieldName := 'SysNachname';
    DataSetSysNachname.Size := 40;
    DataSetSysVorname.SetParentComponent(DataSet);
    DataSetSysVorname.Name := 'DataSetSysVorname';
    DataSetSysVorname.FieldName := 'SysVorname';
    DataSetSysVorname.Size := 40;
    DataSetNetzwerk.SetParentComponent(DataSet);
    DataSetNetzwerk.Name := 'DataSetNetzwerk';
    DataSetNetzwerk.FieldName := 'Netzwerk';
    DataSetDBKEY.SetParentComponent(DataSet);
    DataSetDBKEY.Name := 'DataSetDBKEY';
    DataSetDBKEY.FieldName := 'DBKEY';
    DataSetDBKEY.Size := 50;
    DataSetVerarbeitung.SetParentComponent(DataSet);
    DataSetVerarbeitung.Name := 'DataSetVerarbeitung';
    DataSetVerarbeitung.FieldName := 'Verarbeitung';
    DataSetVerarbeitung.Size := 1;
    DataSetCadiaModSumme.SetParentComponent(DataSet);
    DataSetCadiaModSumme.Name := 'DataSetCadiaModSumme';
    DataSetCadiaModSumme.FieldName := 'CadiaModSumme';
    DataSetASPVersion.SetParentComponent(DataSet);
    DataSetASPVersion.Name := 'DataSetASPVersion';
    DataSetASPVersion.FieldName := 'ASPVersion';
    DataSetASPVersion.Size := 10;
    DataSetCSPName.SetParentComponent(DataSet);
    DataSetCSPName.Name := 'DataSetCSPName';
    DataSetCSPName.FieldName := 'CSPName';
    DataSetCSPName.Size := 50;
    DataSetCSPVendor.SetParentComponent(DataSet);
    DataSetCSPVendor.Name := 'DataSetCSPVendor';
    DataSetCSPVendor.FieldName := 'CSPVendor';
    DataSetCSPVendor.Size := 50;
    DataSetCPUName.SetParentComponent(DataSet);
    DataSetCPUName.Name := 'DataSetCPUName';
    DataSetCPUName.FieldName := 'CPUName';
    DataSetCPUName.Size := 50;
    DataSetCPUID.SetParentComponent(DataSet);
    DataSetCPUID.Name := 'DataSetCPUID';
    DataSetCPUID.FieldName := 'CPUID';
    DataSetCPUID.Size := 50;
    DataSetBaseBoardSerial.SetParentComponent(DataSet);
    DataSetBaseBoardSerial.Name := 'DataSetBaseBoardSerial';
    DataSetBaseBoardSerial.FieldName := 'BaseBoardSerial';
    DataSetBaseBoardSerial.Size := 50;
    DataSetHDDVolLetter.SetParentComponent(DataSet);
    DataSetHDDVolLetter.Name := 'DataSetHDDVolLetter';
    DataSetHDDVolLetter.FieldName := 'HDDVolLetter';
    DataSetHDDVolLetter.Size := 50;
    DataSetHDDVolSerial.SetParentComponent(DataSet);
    DataSetHDDVolSerial.Name := 'DataSetHDDVolSerial';
    DataSetHDDVolSerial.FieldName := 'HDDVolSerial';
    DataSetHDDVolSerial.Size := 50;
    DataSetSQLDB.SetParentComponent(DataSet);
    DataSetSQLDB.Name := 'DataSetSQLDB';
    DataSetSQLDB.FieldName := 'SQLDB';
    DataSetSQLDB.Size := 1;
    DataSetIPAdresse.SetParentComponent(DataSet);
    DataSetIPAdresse.Name := 'DataSetIPAdresse';
    DataSetIPAdresse.FieldName := 'IPAdresse';
    DataSetIPAdresse.Size := 50;
    DataSetInstanzID.SetParentComponent(DataSet);
    DataSetInstanzID.Name := 'DataSetInstanzID';
    DataSetInstanzID.FieldName := 'InstanzID';
    DataSetInstanzID.Size := 50;
    DataSetProgrammpfad.SetParentComponent(DataSet);
    DataSetProgrammpfad.Name := 'DataSetProgrammpfad';
    DataSetProgrammpfad.FieldName := 'Programmpfad';
    DataSetProgrammpfad.Size := 255;
    DataSetLocalIP.SetParentComponent(DataSet);
    DataSetLocalIP.Name := 'DataSetLocalIP';
    DataSetLocalIP.FieldName := 'LocalIP';
    DataSetLocalIP.Size := 50;
    DataSetMACAddress.SetParentComponent(DataSet);
    DataSetMACAddress.Name := 'DataSetMACAddress';
    DataSetMACAddress.FieldName := 'MACAddress';
    DataSetMACAddress.Size := 50;
    DataSetVersionsnummer.SetParentComponent(DataSet);
    DataSetVersionsnummer.Name := 'DataSetVersionsnummer';
    DataSetVersionsnummer.FieldName := 'Versionsnummer';
    DataSetDatenpfad.SetParentComponent(DataSet);
    DataSetDatenpfad.Name := 'DataSetDatenpfad';
    DataSetDatenpfad.FieldName := 'Datenpfad';
    DataSetDatenpfad.Size := 255;
    Source.SetParentComponent(Self);
    Source.Name := 'Source';
    Source.DataSet := DataSet;
    Source.Left := 56;
    Source.Top := 56;
  finally
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    DataSet.AfterLoadDFMValues;
    DataSetID.AfterLoadDFMValues;
    DataSetDatumUhrzeit.AfterLoadDFMValues;
    DataSetApplicationCode.AfterLoadDFMValues;
    DataSetApplicationName.AfterLoadDFMValues;
    DataSetVersionsdatum.AfterLoadDFMValues;
    DataSetInstalCode.AfterLoadDFMValues;
    DataSetFreischaltungVON.AfterLoadDFMValues;
    DataSetFreischaltungBIS.AfterLoadDFMValues;
    DataSetAbsenderzeile.AfterLoadDFMValues;
    DataSetPCCode.AfterLoadDFMValues;
    DataSetVertriebspartner.AfterLoadDFMValues;
    DataSetLetzterStart.AfterLoadDFMValues;
    DataSetAnzahlStart.AfterLoadDFMValues;
    DataSetDatumUhrzeitUser.AfterLoadDFMValues;
    DataSetWindowsUserName.AfterLoadDFMValues;
    DataSetCadiaKundennummer.AfterLoadDFMValues;
    DataSetPCName.AfterLoadDFMValues;
    DataSetAvIsTrial.AfterLoadDFMValues;
    DataSetAvAuthorized.AfterLoadDFMValues;
    DataSetAvRegistered.AfterLoadDFMValues;
    DataSetAvExpired.AfterLoadDFMValues;
    DataSetSysNachname.AfterLoadDFMValues;
    DataSetSysVorname.AfterLoadDFMValues;
    DataSetNetzwerk.AfterLoadDFMValues;
    DataSetDBKEY.AfterLoadDFMValues;
    DataSetVerarbeitung.AfterLoadDFMValues;
    DataSetCadiaModSumme.AfterLoadDFMValues;
    DataSetASPVersion.AfterLoadDFMValues;
    DataSetCSPName.AfterLoadDFMValues;
    DataSetCSPVendor.AfterLoadDFMValues;
    DataSetCPUName.AfterLoadDFMValues;
    DataSetCPUID.AfterLoadDFMValues;
    DataSetBaseBoardSerial.AfterLoadDFMValues;
    DataSetHDDVolLetter.AfterLoadDFMValues;
    DataSetHDDVolSerial.AfterLoadDFMValues;
    DataSetSQLDB.AfterLoadDFMValues;
    DataSetIPAdresse.AfterLoadDFMValues;
    DataSetInstanzID.AfterLoadDFMValues;
    DataSetProgrammpfad.AfterLoadDFMValues;
    DataSetLocalIP.AfterLoadDFMValues;
    DataSetMACAddress.AfterLoadDFMValues;
    DataSetVersionsnummer.AfterLoadDFMValues;
    DataSetDatenpfad.AfterLoadDFMValues;
    Source.AfterLoadDFMValues;
  end;
end;

end.
